import { RichText } from "@components/cms/rich-text-renderer/RichText";
import type { Document } from "@contentful/rich-text-types";
import { Box } from "@ecco/ui/box";
import React from "react";
import { getSeparatorStyle, messageItemStyle } from "./USPMessagesList.styles";

interface USPMessagesListProps {
    messages: Document[];
    showSeparator?: boolean;
    keyPrefix?: string;
    isSaleSeason?: boolean;
}

export const USPMessagesList: React.FC<USPMessagesListProps> = ({
    messages,
    showSeparator = true,
    keyPrefix = "",
    isSaleSeason = false,
}) => {
    const separatorStyle = getSeparatorStyle(isSaleSeason);
    const lastIndex = messages.length - 1;

    return (
        <>
            {messages.map((item, i) => {
                const isLast = i === lastIndex;

                // ✅ In the first marquee copy, also show a separator after the last item
                // (keyPrefix is empty). The second copy ("dup-") will skip it.
                const shouldShowSeparator = showSeparator && (!isLast || keyPrefix === "");

                return (
                    <Box key={`${keyPrefix}${i}`} sx={messageItemStyle}>
                        <RichText data={item} />
                        {shouldShowSeparator && (
                            <Box as="span" sx={separatorStyle}>
                                •
                            </Box>
                        )}
                    </Box>
                );
            })}
        </>
    );
};

export default USPMessagesList;
